module.exports = __webpack_public_path__ + "img/site_cover.e726a2b8.png";